import { render, staticRenderFns } from "./SkillSelect.vue?vue&type=template&id=550970e0&scoped=true"
import script from "./SkillSelect.vue?vue&type=script&lang=js"
export * from "./SkillSelect.vue?vue&type=script&lang=js"
import style0 from "./SkillSelect.vue?vue&type=style&index=0&id=550970e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550970e0",
  null
  
)

export default component.exports